export const LocalizedStrings = {
  TurnedOn: $localize`Zapnuto`,
  TurnedOff: $localize`Vypnuto`,
  EmptyValue: $localize`---`,
  Input: $localize`Vstup`,
  ServerError: $localize`Oops! Něco se pokazilo. Zkuste to prosím znovu.`,
  RefreshTokenError: $localize`Chyba autorizace`,
};
